import type React from "react";
import { ReactComponent as Svg } from "./assets/lock.svg";
import * as styles from "./Icon.module.scss";

type LockProps = React.SVGProps<SVGSVGElement>;

export const Lock = ({ className, ...props }: LockProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
